import { forwardRef, ModalContent, ModalContentProps } from "@chakra-ui/react";
import React, { useRef } from "react";
import { OverlayPortalContainerProvider } from "./OverlayPortalContainerContext";

export const AppModalContent = forwardRef<ModalContentProps, "section">(
  function AppModalContent({ children, ...props }, _ref) {
    const containerRef = useRef<HTMLElement | null>(null);

    return (
      <ModalContent ref={containerRef} {...props}>
        <OverlayPortalContainerProvider containerRef={containerRef}>
          {children}
        </OverlayPortalContainerProvider>
      </ModalContent>
    );
  },
);
